import { c as _c } from "react/compiler-runtime";
import { ActionButtonContainer } from "@components/action-buttons/action-button-container";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { ShareProjectButton } from "@components/project/share-project-button";
import { ArchiveIcon, UnarchiveIcon, DeleteIcon, DownloadIcon, Tooltip } from "@flat-ui";
import { useProjectActions } from "@hooks/projects/use-project-actions";
import { DeleteProject } from "@pages/project-details/project-overview/delete-project";
import { useState } from "react";

/**
 * List of all the buttons that will be shown on project overview tab
 */
export function ProjectOverviewActionButtons(t0) {
  const $ = _c(22);
  const {
    project
  } = t0;
  const [shouldShowDialog, setShouldShowDialog] = useState(false);
  const {
    archiveOrUnarchiveProject,
    isProjectActive,
    isAllowedToArchiveOrUnarchive,
    isArchiveActionDisabled,
    canDeleteProject,
    canDownloadFromVault,
    openInSphereVault
  } = useProjectActions(project);
  let t1;
  if ($[0] !== archiveOrUnarchiveProject || $[1] !== isAllowedToArchiveOrUnarchive || $[2] !== isArchiveActionDisabled || $[3] !== isProjectActive) {
    t1 = isAllowedToArchiveOrUnarchive && <ActionButtonContainer><Tooltip component="div" title={`${isProjectActive ? "Archive" : "Unarchive"} project`}><SphereIconButton isDisabled={isArchiveActionDisabled} component={isProjectActive ? ArchiveIcon : UnarchiveIcon} onClick={() => archiveOrUnarchiveProject()} /></Tooltip></ActionButtonContainer>;
    $[0] = archiveOrUnarchiveProject;
    $[1] = isAllowedToArchiveOrUnarchive;
    $[2] = isArchiveActionDisabled;
    $[3] = isProjectActive;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== canDownloadFromVault || $[6] !== openInSphereVault) {
    t2 = canDownloadFromVault && <ActionButtonContainer><Tooltip component="div" title="Download from Sphere Vault"><SphereIconButton component={DownloadIcon} onClick={openInSphereVault} /></Tooltip></ActionButtonContainer>;
    $[5] = canDownloadFromVault;
    $[6] = openInSphereVault;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== project) {
    t3 = <ActionButtonContainer><ShareProjectButton project={project} location="project-overview-page" /></ActionButtonContainer>;
    $[8] = project;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== canDeleteProject || $[11] !== isProjectActive) {
    t4 = !isProjectActive && canDeleteProject && <ActionButtonContainer><Tooltip component="div" title="Delete Project"><SphereIconButton component={DeleteIcon} onClick={() => setShouldShowDialog(true)} /></Tooltip></ActionButtonContainer>;
    $[10] = canDeleteProject;
    $[11] = isProjectActive;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== project || $[14] !== shouldShowDialog) {
    t5 = shouldShowDialog && <DeleteProject project={project} onClose={() => setShouldShowDialog(false)} />;
    $[13] = project;
    $[14] = shouldShowDialog;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t1 || $[17] !== t2 || $[18] !== t3 || $[19] !== t4 || $[20] !== t5) {
    t6 = <>{t1}{t2}{t3}{t4}{t5}</>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
}